import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    q: "How do fireplace and chimney companies get more leads in Colorado?",
    a: "Local SEO and a tuned Google Business Profile do the heavy lifting. 'Chimney sweep near me', 'fireplace repair', and 'gas fireplace installation' are all distinct searches. The companies that build a separate page per service capture every angle.",
  },
  {
    q: "When does fireplace and chimney demand peak?",
    a: "September through January, with a smaller wave in spring for clean-and-inspect bookings. Your site needs to rank by August or you miss the booking surge. Cold-launching pages in November never indexes in time.",
  },
  {
    q: "Is Google Ads worth it for chimney sweeps?",
    a: "Yes, especially during fall pre-season and after CO 2 alarm news cycles. We build campaigns that target inspection and sweep keywords aggressively September–November, and back off in May–July.",
  },
  {
    q: "What about gas fireplace installs versus wood-burning?",
    a: "Treat them as separate pages with separate ads. Gas fireplace buyers behave like remodel customers — longer research, higher ticket. Wood-burning chimney sweeps are urgent, short-cycle. One page can't convert both audiences.",
  },
  {
    q: "Do you handle dryer vent cleaning marketing too?",
    a: "Yes — most chimney sweeps also do dryer vents and that's a high-margin add-on with year-round demand. We build dedicated dryer-vent pages so you rank for both queries from one domain.",
  },
];

export const Route = createFileRoute("/fireplace-chimney-marketing-colorado")({
  head: () =>
    industryMarketingHead("Fireplace & Chimney", "fireplace and chimney company", "fireplace-chimney-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry="Fireplace & Chimney"
      industryLower="fireplace and chimney company"
      slug="fireplace-chimney-marketing-colorado"
      subheadline="We help Colorado chimney sweeps and fireplace installers fill the fall booking surge and win year-round dryer-vent work between seasons."
      painPoints={[
        "Fall inspection season fills competitors' calendars while your phone stays quiet",
        "One 'chimney services' page is invisible for 'chimney sweep', 'gas fireplace install', and 'dryer vent cleaning'",
        "Gas-fireplace remodel buyers never find you — your site reads like a sweep, not a showroom",
      ]}
      serviceDescriptions={{
        seo: "Rank for chimney sweep, fireplace install, gas conversion, dryer vents, and inspection — every service, every Colorado city.",
        googleMaps: "Own 'chimney sweep near me' in the Map Pack before the first cold snap.",
        webDesign: "Showroom-quality sites that convert remodel buyers and urgent inspection bookings from the same domain.",
        ppc: "Pre-season Google Ads (Sept–Nov) that capture booking-surge demand without burning summer budget.",
        geoAi: "Get cited when homeowners ask ChatGPT 'should I get my chimney swept' or 'best gas fireplace installer near me'.",
        socialMedia: "Safety-driven content that builds trust before homeowners pick up the phone.",
      }}
      testimonial={{
        quote:
          "Our fall calendar booked solid by mid-October. The separate pages for sweeps, gas installs, and dryer vents finally gave us search coverage we never had.",
        role: "Fireplace & Chimney Owner",
        city: "Colorado Springs",
      }}
      faqs={FAQS}
      cityHubLinks={[
        { to: "/colorado-springs", label: "Fireplace & chimney marketing in Colorado Springs", description: "Capture fall inspection and gas-install demand across the Pikes Peak region." },
        { to: "/denver-digital-marketing", label: "Fireplace & chimney marketing in Denver", description: "Compete for remodel, install, and chimney-sweep work across the Denver metro." },
        { to: "/castle-rock-digital-marketing", label: "Fireplace & chimney marketing in Castle Rock", description: "High-end gas fireplace installs and inspections across Castle Rock and Castle Pines." },
      ]}
    />
  ),
});
